<script lang="ts">
  import { page } from '$app/stores';
  import { is_set_array } from '$lib/js/helpers';
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let type = '' // '' || universe
  let subcats: { product_count: number, url_path: string, name: string }[] = []

	const scope = getContextScope()

  $: if(is_set_array($page.data.subcats)) {
    subcats = $page.data.subcats
  }
</script>


{#if subcats.length > 0}
  <div class="subcategories {type}">
    <div class="subcategories__inner">
      {#each subcats as subcat}
        {#if subcat.product_count > 0}
          <a href="/{scope}/{subcat.url_path}" class="subcategories__cat">
            <h3>{subcat.name}</h3>
          </a>
        {/if}
      {/each}
    </div>
  </div>
{/if}


<style lang="scss">
  .subcategories {
    margin: 20px 0 30px;

    &__inner {
      display: flex;
      flex-wrap: wrap;
      margin-left: -6px;
      margin-right: -6px;
    }

    &__cat {
      width: calc(100% / 2 - 42px);
      padding: 6px 15px;
      margin: 8px 6px;
      transition: all linear 0.125s;
      outline: 1px solid black;
      // border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (min-width: 425px) {
        width: calc(100% / 3 - 42px);
      }

      @media (min-width: 580px) {
        width: calc(100% / 4 - 42px);
      }

      @media (min-width: 1025px) {
        width: calc(100% / 6 - 42px);
      }

      @media (min-width: 1201px) {
        width: calc(100% / 8 - 42px);
      }

      &:hover {
        @media (min-width: 769px) {
          transform: scale(1.05);
        }
      }

      img {
        width: 100%;
        height: 120px;
        object-fit: contain;
        margin-bottom: 5px;
      }

      h3 {
        font-size: 14px;
        margin: 0;
        text-align: center;
      }
    }

    &.universe {
      .subcategories {
        &__cat {
          padding: 10px 15px;
          outline: none;
          background: var(--univ-main);
        }
      }
    }
  }
</style>
